<template>
  <div class="component-wrap bg-gray" v-if="dataList">
    <div class="analysis-title-box">
      <h3 class="analysis-title">많이 본 채널</h3>
    </div>
    <div v-if="dataList.length" class="mypooq-swiper-container my-component03" id="swiper-container03">
      <ul class="mypooq-swiper-wrapper">
        <li class="mypooq-swiper-slide" v-for="(data, index) in dataList" :key="index">
          <a href="" @click.prevent="()=>goLive(data)">
            <span class="vod-img"><img :src="'https://' + data.image" alt=""/></span>
            <span class="thumb-text-wrap">
              <span class="thumb-text-right">
                <strong class="thumb-title-two">{{data.channelname}}</strong>
                <span class="thumb-text01">{{Math.ceil(data.viewtime / 3600)}}시간</span>
              </span>
            </span>
          </a>
        </li>
      </ul>
      <span class="scrollbar-none"></span>
    </div>
    <div v-else class="my-list-empty">
      <empty-list></empty-list>
      <p>이용한 콘텐츠가 없어요.</p>
      <p>지금 바로 시청해 보시는 건 어때요?</p>
      <a @click.prevent="goHome" class="my-empty-btn">
        <span>홈으로 이동하기</span>
        <ResearchButton />
      </a>
    </div>
  </div>
</template>

<script>
import EmptyList from '@/assets/svg/common/img_empty.svg'
import ResearchButton from '@/assets/svg/common/ic-research.svg'
export default {
  name: 'AnalysisChannelList',
  components: {
    ResearchButton,
    EmptyList
  },
  props: {
    dataList: {
      type: Array,
      required: true
    },
    device: {
      type: String
    }
  },
  methods: {
    goLive (data) {
      if (this.device === 'mobile') {
        this.$router.push(`/player/live?channelid=${data.channelid}`)
      } else {
        location.href = 'captvpooq://player/live?channelid=' + data.channelid
      }
    },
    goHome () {
      if (this.device === 'mobile') {
        this.$router.push('/')
      } else {
        location.href = 'captvpooq://index'
      }
    }
  }
}
</script>

<style lang="css">
  .mypooq-swiper-container{
    position: relative;
    width: 100%;
    display: flex;
  }
  .my-component03 .mypooq-swiper-wrapper{
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    /*padding-bottom: 10px;*/
    padding: 0 10px 10px;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .mypooq-swiper-wrapper::-webkit-scrollbar{
    display: none;
    background-color: transparent;
  }
  .mypooq-swiper-wrapper::-webkit-scrollbar-thumb {
    display: none;
    background-color: transparent;
  }
  .my-component03 .scrollbar-none{
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 8px;
    z-index: 1000;
    border: 1px solid #1b1b1b;
    background-color: #1b1b1b;
  }

.mypooq-swiper-slide{
  flex: 0 0 auto;
}

.my-component03{
  /*padding: 0 10px;*/
}

.my-component03 .mypooq-swiper-slide{
  width: 100px !important;
  background-color: #5e5e5e;
  border-radius: 4px;
  margin-left: 10px;
  padding: 20px 10px 11px;
}

.my-component03 .mypooq-swiper-slide:first-child{
  margin-left: 0;
}

.my-component03 .vod-img{
  display: block;
  text-align: center;
}

.my-component03 .vod-img img{
  width: 100%;
  max-height: 100%;
}

.my-component03 .thumb-text-wrap{
  padding-top: 20px;
}

.my-component03 .thumb-text01{
  margin-top: 0;
}
</style>
